<template>
    <div>
        <div id="main-content" class="container">
            <div class="row">
                <div class="col-md-6">
                    <form class="form-inline">
                        <div class="form-group">
                            <label for="connect">WebSocket connection:</label>
                            <button id="connect" class="btn btn-default" type="submit" :disabled="connected == true" @click.prevent="connect">
                                Connect
                            </button>
                            <button id="disconnect" class="btn btn-default" type="submit" :disabled="connected == false" @click.prevent="disconnect">
                                Disconnect
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-md-6">
                    <form class="form-inline">
                        <div class="form-group">
                            <label for="name">Enter display ID:</label>
                            <input type="text" id="name" class="form-control" v-model="send_message" placeholder="Your name here...">
                        </div>
                        <button id="send" class="btn btn-default" type="submit" @click.prevent="send">Send</button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12" style="overflow: auto; height: 75vh;">
                    <table id="conversation" class="table table-striped">
                        <thead>
                        <tr>
                            <th>Greetings</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in received_messages" :key="index">
                            <td>{{ item }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";
    import {config} from "../../config";

    export default {
        name: "test",
        data() {
            return {
                received_messages: [],
                send_message: 1,
                connected: false
            };
        },
        methods: {
            send() {
                console.log("Send message:" + this.send_message);
                if (this.stompClient && this.stompClient.connected) {
                    const msg = {displayId: this.send_message};

                    this.stompClient.subscribe(`/displays/announcements/${this.send_message}`, message => {
                       this.received_messages.push(JSON.parse(message.body));
                       console.log(message);
                    });


                    this.stompClient.send("/app/displays/request-announcements", JSON.stringify(msg), {});
                }
            },
            connect() {
                this.socket = new SockJS( config.serverUrl + "socket");
                this.stompClient = Stomp.over(this.socket);
                this.stompClient.connect({},
                    frame => {
                        this.connected = true;
                        console.log(frame);
                        // this.stompClient.subscribe("/displays", message => {
                        //     this.received_messages.push(JSON.parse(message.body));
                        //     console.log(message.body)
                        // });
                    },
                    error => {
                        console.log(error);
                        this.connected = false;
                    }
                );
            },
            disconnect() {
                if (this.stompClient) {
                    this.stompClient.disconnect();
                }
                this.connected = false;
            },
            tickleConnection() {
                this.connected ? this.disconnect() : this.connect();
            }
        },
        mounted() {
            this.connect();
        }
    };
</script>

<style scoped>

</style>
